import { defineMessage } from 'services/localization';

export const messages = {
    sectionTitle: defineMessage('make_a_decision_on_quote'),
    declineButtonTitle: defineMessage('decline'),
    acceptButtonTitle: defineMessage('accept'),
};
